import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription
} from '@/components/ui/dialog';
import { Loader2, Trash2 } from 'lucide-react';

// Delete-load confirmation dialog. Shows container/job/status for context.
export const DeleteConfirmDialog = ({ open, onOpenChange, shipment, deleting, onConfirm }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-slate-900 border-slate-800 sm:max-w-md">
      <DialogHeader>
        <DialogTitle className="text-red-400">Delete Load</DialogTitle>
        <DialogDescription className="text-slate-400">
          Are you sure you want to delete this load? This action cannot be undone.
        </DialogDescription>
      </DialogHeader>
      <div className="py-4">
        <div className="p-3 bg-slate-800 rounded-lg">
          <p className="text-slate-300">
            <span className="text-slate-500">Container:</span>{' '}
            <span className="font-mono font-bold text-white">{shipment?.container_number}</span>
          </p>
          <p className="text-slate-300">
            <span className="text-slate-500">Job #:</span>{' '}
            <span className="font-mono">{shipment?.job_number?.replace(/^JOB/i, '')}</span>
          </p>
          <p className="text-slate-300">
            <span className="text-slate-500">Status:</span> <span>{shipment?.status}</span>
          </p>
        </div>
      </div>
      <DialogFooter className="gap-2">
        <Button variant="outline" onClick={() => onOpenChange(false)} className="border-slate-700">Cancel</Button>
        <Button onClick={onConfirm} disabled={deleting} className="bg-red-600 hover:bg-red-500" data-testid="confirm-delete-btn">
          {deleting
            ? (<><Loader2 className="h-4 w-4 animate-spin mr-2" />Deleting...</>)
            : (<><Trash2 className="h-4 w-4 mr-2" />Delete Load</>)}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
